import { AboutHero } from '@/components/about/AboutHero'
import { AboutStory } from '@/components/about/AboutStory'
import { AboutJourney } from '@/components/about/AboutJourney'
import { AboutPhilosophy } from '@/components/about/AboutPhilosophy'
import { AboutCredentials } from '@/components/about/AboutCredentials'
import { AboutPullQuote } from '@/components/about/AboutPullQuote'

export const AboutPage = () => (
  <>
    <AboutHero />
    <AboutStory />
    <AboutJourney />
    <AboutPhilosophy />
    <AboutCredentials />
    <AboutPullQuote />
  </>
)
